import { useCallback, useState } from 'react';
import type { AxiosInstance } from 'axios';
import { setCasePrioridade, type CaseRecordData } from '@/lib/cases';

/**
 * Alterna a prioridade de um caso e troca o registro na lista (E60.F3). // ux-neutrality:allow doc-comment
 *
 * Extraído da `CasosPage` para manter a página sob o limite de linhas do ESLint. A ordem não é // ux-neutrality:allow doc-comment
 * daqui: a página ordena o que mostra pela régua da lista (`ordemDaLista`, owner 03/11), e o // ux-neutrality:allow doc-comment
 * caso marcado sobe sozinho. // ux-neutrality:allow doc-comment
 */
interface UsePrioridadeCaso {
  emVoo: string | null;
  alternar: (alvo: CaseRecordData) => Promise<void>;
}

export function usePrioridadeCaso(
  client: AxiosInstance,
  aplicar: (atualizar: (atuais: CaseRecordData[] | null) => CaseRecordData[] | null) => void,
  aoFalhar: () => void,
): UsePrioridadeCaso {
  const [emVoo, setEmVoo] = useState<string | null>(null);

  const alternar = useCallback(
    async (alvo: CaseRecordData): Promise<void> => {
      setEmVoo(alvo.id);
      try {
        const atualizado = await setCasePrioridade(client, alvo.id, alvo.prioritario !== true);
        aplicar((atuais) =>
          atuais === null ? atuais : atuais.map((c) => (c.id === atualizado.id ? atualizado : c)),
        );
      } catch {
        aoFalhar();
      } finally {
        setEmVoo(null);
      }
    },
    [aplicar, aoFalhar, client],
  );

  return { emVoo, alternar };
}
